import { useEffect } from 'react';

/**
 * SEO Component for dynamic meta tags
 * Updates document head with SEO metadata for each page
 */
export default function SEO({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  siteName = 'Protek Studio Design',
}) {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
  const imageUrl = image ? (image.startsWith('http') ? image : `${baseUrl}${image}`) : `${baseUrl}/logo512.png`;

  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }

    // Helper function to update or create meta tag
    const updateMetaTag = (property, content) => {
      if (!content) return;
      
      // Twitter uses name attribute, Open Graph uses property attribute
      const isTwitter = property.startsWith('twitter:');
      const isOpenGraph = property.startsWith('og:');
      
      let element = isTwitter 
        ? document.querySelector(`meta[name="${property}"]`)
        : isOpenGraph
        ? document.querySelector(`meta[property="${property}"]`)
        : document.querySelector(`meta[name="${property}"]`) || document.querySelector(`meta[property="${property}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        if (isOpenGraph) {
          element.setAttribute('property', property);
        } else {
          element.setAttribute('name', property);
        }
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    
    // Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', imageUrl);
    updateMetaTag('og:url', fullUrl);
    updateMetaTag('og:type', type);
    updateMetaTag('og:site_name', siteName);
    updateMetaTag('og:locale', 'en_US');

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', imageUrl);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);

  }, [title, description, keywords, imageUrl, fullUrl, type, siteName]);

  return null;
}
